import { createContext, useContext } from 'react';
import WebSocketManager from '../util/notificationSocketManager';

const WebSocketContext = createContext();
/**
 * Custom hook to use the WebSocket context.
 * @returns {WebSocketManager | null} The WebSocket context value.
 */
const useWebSocketContext = () => {
    return useContext(WebSocketContext);
};

export { WebSocketContext, useWebSocketContext };
